import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import style from './currentCoinComponent.module.css'
const CustomButton = dynamic(() => import('../../buttons/customButton'))
const IconPhone = dynamic(() => import('../../icons/iconPhone'))
const IconEmail = dynamic(() => import('../../icons/iconEmail'))

const CurrentCoinContact = () => {
    const router = useRouter()
    return (<address className="sectionOrArticleB">
        <Container>
            <Row className='justify-content-center'>
                <Col xs={12} sm={11} md={10} lg={8} xl={7} >

                    <Card className={style.contactCard}>
                        <Card.Body>
                            <Card.Subtitle className="mb-2 p-3 text-muted bg-warning">
                                If you are interested in this item, please contact us:
                            </Card.Subtitle>

                            <div className='text-center'>
                                <div className='my-xs-1 my-md-2 my-lg-3'>
                                    <CustomButton blueBtn onClick={() => router.push('/contact')}>Contact Us</CustomButton>
                                </div>
                                <p>Call Us</p>
                                <div className='d-flex justify-content-center' ><IconPhone
                                    color={'#f2f2f2'}
                                    size={'1rem'}
                                    title={'Call Us'}
                                />&nbsp;
                                    <a href="tel:+17276562974"><p>+1-727-656-2974</p></a>
                                </div>
                                <p>Email Us</p>
                                <div className='d-flex justify-content-center' ><IconEmail
                                    color={'#f2f2f2'}
                                    size={'1rem'}
                                    title={'Email Us'}
                                />&nbsp;
                                    <a href="mailto:coinomania@gmail.com"><p>coinomania@gmail.com</p></a>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    </address>)
}
export default CurrentCoinContact